<template>
  <div class="flex flex-col gap-y-8">
    <div class="bg-white p-4 rounded shadow">
      <h2 class="mb-2 text-lg font-bold">Déconnexion</h2>
      <button @click="logout" class="bg-red-500 text-white w-32 py-2 rounded font-bold">Déconnexion</button>
    </div>
    <div class="bg-white p-4 rounded shadow">
      <h2 class="text-lg font-bold">Redémarrage</h2>
      <p class="mb-2">Si vous avez un problème essayer de redémarrer par le bouton si desous d'abord</p>
      <button @click="restart" class="bg-orange-400 text-white w-32 py-2 rounded font-bold">Redémarrer</button>
    </div>
    <div class="bg-white p-4 rounded shadow">
      <h2 class="mb-2 text-lg font-bold">Changement mot de passe</h2>
      <label for="oldPassword" class="block mt-4">Ancien mot de passe</label>
      <input id="oldPassword" type="password" class="input" v-model="formValues.oldPassword" />
      <label for="password" class="block mt-4">Nouveau mot de passe</label>
      <input id="password" type="password" class="input" v-model="formValues.password" />
      <label for="confirmPassword" class="block mt-4">Confirmer le nouveau mot de passe</label>
      <input id="confirmPassword" type="password" class="input" v-model="formValues.confirmPassword" />
      <button
        @click="changePassword"
        class="bg-green-500 text-white w-32 py-2 rounded font-bold mt-6"
        :disabled="loading || empty"
      >
        Sauvegarder
      </button>
    </div>
  </div>
</template>

<script>
import useApi from '@/hooks/useApi'
import { ref, computed } from 'vue'
import cacheBust from '@/hooks/useCacheBust'

export default {
  theme() {
    return {
      title: 'Settings',
    }
  },
  setup() {
    const api = useApi()
    const loading = ref(false)
    const formValues = ref({
      oldPassword: '',
      password: '',
      confirmPassword: '',
    })
    const empty = computed(
      () => !formValues.value.oldPassword || !formValues.value.password || !formValues.value.confirmPassword,
    )
    const logout = async () => {
      await api.auth.logout()
      window.location = '/login?logout=true'
    }
    const restart = () => {
      cacheBust(async () => {
        await api.auth.logout()
        window.location = '/login?refresh=true'
      })
    }
    const changePassword = async () => {
      loading.value = true
      await api.auth
        .passwordChange(formValues.value)
        .then(() => {
          logout()
        })
        .finally(() => {
          loading.value = false
        })
    }
    return { formValues, empty, loading, logout, restart, changePassword }
  },
}
</script>

<style></style>
